




























import { Prop, Component, Vue } from "vue-property-decorator";
import ScheduleEvent from "../presenters/schedule-event";
import ScheduleEventApi from "@/api/schedule/schedule-event-api";
import { client } from "@/api/request";
import ScheduleEventListItem from "../components/ScheduleEventListItem.vue";
import ScheduleEventList from "../components/ScheduleEventList.vue";
import formatLocaleDate from "../../../helpers/formatLocaleDate";
import User from "../../../models/user";

const eventApi = new ScheduleEventApi(client);

@Component({
  components: {
    ScheduleEventList,
    ScheduleEventListItem
  }
})
export default class ScheduleEventListModal extends Vue {
  @Prop({ type: Boolean }) editable!: boolean;

  public async show(userId: number, date: Date) {
    this.userId = userId;
    this.date = date;
    await this.init(userId, date);
    this.$nextTick(() => {
      (this.$refs.modal as any).show();
    });
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  events: ScheduleEvent[] = [];

  get empty(): boolean {
    return this.events.length === 0;
  }

  get localeDate(): string {
    return formatLocaleDate(this.date);
  }

  isEditable(): boolean {
    return this.editable && this.user.id === this.userId;
  }

  create() {
    this.$emit("create", this.date);
    this.hide();
  }

  edit(id: number) {
    this.$emit("edit", id);
    this.hide();
  }

  private userId: number = 0;
  private date: Date = new Date();

  private get user(): User {
    return this.$store.getters.user;
  }

  private async init(userId: number, date: Date) {
    const events = await eventApi.findByUserAndDate(userId, date);
    this.events = events.map(e => new ScheduleEvent(e));
    console.log(this.events);
  }
}
